export type Artwork = { id: string; name: string; imageUrl: string };
export type SidebarPropId = string;

export function readArtworkLibrary(settings: Record<string, string>): Artwork[] {
  try {
    const rows: unknown = JSON.parse(settings.artwork_library ?? settings.about_us_artworks ?? "[]");
    const ids = new Set<string>();
    if (!Array.isArray(rows)) return [];
    return rows.filter(row => row && typeof row === "object" && typeof row.imageUrl === "string" && (/^https?:\/\//i.test(row.imageUrl) || /^\/media\/(artworks|gallery)\//.test(row.imageUrl))).slice(0, 24).map((row, index) => {
      let id = String(row.id || `artwork-${index}`);
      while (id === "none" || ids.has(id)) id += `-${index}`;
      ids.add(id);
      return { id, name: String(row.name || "Artwork"), imageUrl: row.imageUrl };
    });
  } catch { return []; }
}

export function normalizeSidebarProp(value?: string): SidebarPropId {
  return value?.trim() || "none";
}

export function readSidebarArtwork(settings: Record<string, string>) {
  return readArtworkLibrary(settings).find(item => item.id === normalizeSidebarProp(settings.sidebar_prop)) ?? null;
}
